/** @format */

import { Chain } from '@shared/data-access/interfaces';
import {
	Component,
	ComponentRef,
	effect,
	inject,
	Input,
	OnInit,
	TemplateRef,
	viewChild
} from '@angular/core';
import { BreakpointsService, UtilityService } from '@shared/utils/services';
import { HomrInStoreServices } from '@shared/homr/data-access';
import { HmfDrawerComponent, HmfModalFactoryService } from '@dsg-tech/homefield-angular';
import { DynamicDrawerSizes, ProductSelectionUtilityService } from '@pdp/utils';

@Component({
    selector: 'pdp-in-store-services',
    templateUrl: './in-store-services.component.html',
    styleUrls: ['./in-store-services.component.scss'],
    standalone: false
})
export class ProductInStoreServicesComponent implements OnInit {
	public readonly chain = inject(Chain);
	public readonly utilityService = inject(UtilityService);
	private readonly pdslUtilityService = inject(ProductSelectionUtilityService);
	private readonly modalFactoryService = inject(HmfModalFactoryService);
	private readonly breakpointsService = inject(BreakpointsService);

	public chainIdentifierAbbr = this.chain.chainIdentifierAbbr;

	private drawerRef: ComponentRef<HmfDrawerComponent>;
	drawerContent = viewChild.required<TemplateRef<unknown>>('drawerContent');

	@Input() homrInStoreServicesContent: HomrInStoreServices;

	constructor() {
		effect(() => {
			const breakpoint = this.breakpointsService.breakpoint();
			if (this.drawerRef) {
				this.drawerRef.setInput(
					'size',
					this.pdslUtilityService.getValueByScreenSize(DynamicDrawerSizes, breakpoint)
				);
			}
		});
	}

	ngOnInit() {
		if (this.homrInStoreServicesContent.primaryPanelContent) {
			this.homrInStoreServicesContent.primaryPanelContent = decodeURIComponent(
				this.homrInStoreServicesContent.primaryPanelContent
			);
		}
		if (this.homrInStoreServicesContent.secondaryPanelContent) {
			this.homrInStoreServicesContent.secondaryPanelContent = decodeURIComponent(
				this.homrInStoreServicesContent.secondaryPanelContent
			);
		}
	}

	openDrawer() {
		if (!this.drawerRef) {
			this.drawerRef = this.modalFactoryService.create(
				HmfDrawerComponent,
				{
					headerText: this.homrInStoreServicesContent?.panelTitle,
					closable: true,
					mobilePeek: true,
					closableVariant: 'primary',
					closableSide: 'right',
					direction: 'right',
					isCloseButtonSticky: true,
					size: this.pdslUtilityService.getValueByScreenSize(
						DynamicDrawerSizes,
						this.breakpointsService.breakpoint()
					)
				},
				this.drawerContent()
			);
		}

		this.drawerRef.instance.openDrawer();
	}
}
